"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var options_pane_html_1 = __importDefault(require("./options-pane.html"));
var options_settings_html_1 = __importDefault(require("./options-settings.html"));
var options_style_html_1 = __importDefault(require("./options-style.html"));
require("./options-pane.less");
require("./widget-fixed-height-option/widget-fixed-height-option");
(function (module) {
    'use strict';
    OptionsPaneController.$inject = [
        '$scope',
        '$filter',
        '$element',
        'rsWidgets',
        'prFlowingPages',
        'pr.widgetManager',
        'pr.globalOptionsService',
        'pr.widgetOperationsService',
        'prStyleNode',
        'pr.widgetStylesService',
        'prAutoHeightHelper',
        'prActiveReport',
        'pr.STYLE_FORMATS',
        'prConditionalDisplay',
        'prEventService',
        'pr.EVENTS',
        'pr.widgetUtils'
    ];
    function OptionsPaneController($scope, $filter, $element, rsWidgets, flowingPages, widgetManager, globalOptionsService, widgetService, styleNode, widgetStylesService, autoHeight, activeReport, STYLE_FORMATS, conditionalDisplayService, eventService, eventNames, widgetUtils) {
        var translate = $filter('translate');
        var $ctrl = this;
        var WIDGET_TYPES_WITHOUT_PADDING = ['pr.spacer', 'pr.filtersummary'];
        var WIDGET_TYPES_WITH_STYLE = [
            'eng.table',
            'eng.stats',
            'eng.grid',
            'eng.bar',
            'eng.line',
            'eng.pie',
            'eng.gauge',
            'eng.breakdownbar',
            'pr.filtersummary'
        ];
        var ALT_ROWS_PREFIX = 'ALT_ROWS_';
        var TABLE_DENSITY_PREFIX = 'TABLE_DENSITY_STYLE_';
        var HIDE_HEADER_ROW_PREFIX = 'HIDE_HEADER_ROW_';
        var SET_FIRST_COLUMN_WIDTH_PREFIX = 'SET_FIRST_COLUMN_WIDTH_';
        var BULK_DISPLAY_LOGIC = 'bulk';
        $scope.$ctrl = $ctrl;
        $scope.$watch('$ctrl.widgetId', function (after, before) {
            if (before) {
                unloadOptions();
            }
            if (after) {
                loadOptions();
            }
        });
        eventService.on(eventNames.RELOAD_WIDGET_OPTIONS_PANE, reloadOptionsPanel);
        function reloadOptionsPanel() {
            if ($ctrl.widgetId) {
                unloadOptions();
                loadOptions();
            }
            else {
                console.warn('Not reloading options pane because no widget is selected');
            }
        }
        function getOptionsContainerEl() {
            return $element.find('.pr-options-container');
        }
        /**
         * https://qualtrics.atlassian.net/browse/REP-6092
         * @todo - when we close the sidebar, we do not properly destroy
         * the scopes that were created when the sidebar was opened.
         * This leads to a steady increase in the number of scopes and watchers,
         * which hampers app performance during editing.
         */
        function unloadOptions() {
            var _a;
            (_a = getOptionsContainerEl()) === null || _a === void 0 ? void 0 : _a.empty();
        }
        function loadOptions() {
            /**
             * Do not load an individual data-component when multiple widgets are selected.
             * The sidebar for bulk widget editing is part of printed-reports and not data-component.
             */
            if ($ctrl.hasMultipleSelectedWidgets()) {
                return;
            }
            var widget = flowingPages.getWidget($ctrl.widgetId);
            if (widget.layout.style) {
                if (widget.layout.style.enableAltRows) {
                    $ctrl.applyAltRows(true);
                }
                if (autoHeight.isTable(widget._type)) {
                    $ctrl.applyTableBodyDensity(widget.layout.style.tableBodyDensity);
                }
            }
            var pageId = activeReport.getPageIdOfWidget(widget);
            rsWidgets.loadOptions(widget._type, widget._id, getOptionsContainerEl(), null, pageId);
            widgetManager.notifyWidget(widget._id, 'optionsPanelLoaded');
            $scope.$applyAsync();
        }
        function getWidget() {
            return flowingPages.getWidget($ctrl.widgetId);
        }
        angular.extend($ctrl, {
            tabs: [
                {
                    title: translate('SETTINGS'),
                    template: options_settings_html_1.default
                },
                {
                    title: translate('STYLES'),
                    template: options_style_html_1.default
                }
            ],
            getWidgetType: function () {
                return _.get(flowingPages.getWidget($ctrl.widgetId), '_type');
            },
            getWidgetStyle: function () {
                return _.get(flowingPages.getWidget($ctrl.widgetId), 'layout.style', {});
            },
            getClonedWidgetStyle: function () {
                var style = _.get(flowingPages.getWidget($ctrl.widgetId), 'layout.style', {});
                // A deep clone of the style is required because flowingPages.updateWidgetStyle
                // compares the current widget styles to the new widget styles
                // to only trigger saves when a change has occurred. A shallow
                // clone causes the styles to always match.
                return _.cloneDeep(style);
            },
            update: function (nodePrefix, elementType, name, value, section, advStyle) {
                // Section and advStyle are used only for advanced chart styles
                if (!$ctrl.widgetId) {
                    return;
                }
                var style = $ctrl.getClonedWidgetStyle();
                var nodeName = nodePrefix + $ctrl.widgetId;
                var defaultOptions = globalOptionsService.getOptions();
                name = name ? name.toUpperCase() : name;
                switch (elementType) {
                    case STYLE_FORMATS.TABLE_HEADER_TEXT:
                        style.tableHeaderTextFormats = style.tableHeaderTextFormats ||
                            defaultOptions.tableHeaderTextFormats;
                        style.tableHeaderTextFormats[name] = value;
                        widgetStylesService.applyTableHeaderTextStyles($ctrl.widgetId, style.tableHeaderTextFormats, nodeName);
                        break;
                    case STYLE_FORMATS.TABLE_BODY_TEXT:
                        style.tableBodyTextFormats = style.tableBodyTextFormats ||
                            defaultOptions.tableBodyTextFormats;
                        style.tableBodyTextFormats[name] = value;
                        widgetStylesService.applyTableBodyTextStyles($ctrl.widgetId, style.tableBodyTextFormats, nodeName);
                        break;
                    case STYLE_FORMATS.CHART_TEXT:
                        if (section) {
                            // Adv chart style
                            style.chartTextFormats = _.cloneDeep(advStyle);
                            style.chartTextFormats[section][name] = value;
                            widgetStylesService.applyAdvChartTextStyles($ctrl.widgetId, style.chartTextFormats, nodeName);
                        }
                        else {
                            style.chartTextFormats = style.chartTextFormats || defaultOptions.chartTextFormats;
                            style.chartTextFormats[name] = value;
                            if ($ctrl.getWidgetType() === 'eng.breakdownbar') {
                                style.chartTextFormats = _.omit(style.chartTextFormats, ['SIZE']);
                            }
                            widgetStylesService.applyChartTextStyles($ctrl.widgetId, style.chartTextFormats, nodeName);
                        }
                        break;
                    case STYLE_FORMATS.RESPONSE_COUNT_NUMBER:
                        if (!style.responseCountNumberFormats) {
                            // response count number formats default based on body text formats
                            style.responseCountNumberFormats = defaultOptions.bodyTextFormats;
                        }
                        style.responseCountNumberFormats[name] = value;
                        widgetStylesService.applyResponseCountNumberStyles($ctrl.widgetId, style.responseCountNumberFormats, nodeName);
                        break;
                    case STYLE_FORMATS.RESPONSE_COUNT_LABEL:
                        if (!style.responseCountLabelFormats) {
                            // response count label formats default based on body text formats
                            style.responseCountLabelFormats = defaultOptions.bodyTextFormats;
                        }
                        style.responseCountLabelFormats[name] = value;
                        widgetStylesService.applyResponseCountLabelStyles($ctrl.widgetId, style.responseCountLabelFormats, nodeName);
                        break;
                    case STYLE_FORMATS.TABLE_BODY_DENSITY:
                        style.tableBodyDensity = value;
                        widgetStylesService.applyTableBodyDensity($ctrl.widgetId, nodeName, value || globalOptionsService.getTableBodyDensity());
                        break;
                    case STYLE_FORMATS.FILTER_SUMMARY_TEXT_FORMATS:
                        style.filterSummaryTextFormats = style.filterSummaryTextFormats || {};
                        style.filterSummaryTextFormats[section] = style.filterSummaryTextFormats[section] || {};
                        style.filterSummaryTextFormats[section][name] = value;
                        widgetStylesService.applyFilterSummaryStyles($ctrl.widgetId, style.filterSummaryTextFormats, nodeName);
                }
                flowingPages.updateWidgetStyle($ctrl.widgetId, style);
                widgetManager.notifyWidget($ctrl.widgetId, 'widgetStyleChanged', 'WidgetStyleController');
                widgetManager.notifyWidget($ctrl.widgetId, 'resized', 'WidgetStyleController');
            },
            reset: function (nodePrefix, elementType) {
                if (!$ctrl.widgetId) {
                    return;
                }
                var style = $ctrl.getClonedWidgetStyle();
                style = _.omit(style, elementType);
                var nodeName = nodePrefix + $ctrl.widgetId;
                styleNode.removeCSSNode(nodeName);
                flowingPages.updateWidgetStyle($ctrl.widgetId, style);
                widgetManager.notifyWidget($ctrl.widgetId, 'widgetStyleChanged', 'WidgetStyleController');
                widgetManager.notifyWidget($ctrl.widgetId, 'resized', 'WidgetStyleController');
            },
            applyAltRows: function (value) {
                if (!$ctrl.widgetId) {
                    return;
                }
                var style = $ctrl.getClonedWidgetStyle();
                style.enableAltRows = value;
                flowingPages.updateWidgetStyle($ctrl.widgetId, style);
                var nodeName = ALT_ROWS_PREFIX + $ctrl.widgetId;
                if (value) {
                    widgetStylesService.applyTableAltRows($ctrl.widgetId, nodeName);
                }
                else {
                    styleNode.removeCSSNode(nodeName);
                }
            },
            applyTableBodyDensity: function (value) {
                if (!$ctrl.widgetId) {
                    return;
                }
                var style = $ctrl.getClonedWidgetStyle();
                style.tableBodyDensity = value;
                flowingPages.updateWidgetStyle($ctrl.widgetId, style);
                var nodeName = TABLE_DENSITY_PREFIX + $ctrl.widgetId;
                widgetStylesService.applyTableBodyDensity($ctrl.widgetId, nodeName, value || globalOptionsService.getTableBodyDensity());
            },
            repeatTableHeaders: function (value) {
                if (!$ctrl.widgetId) {
                    return;
                }
                var style = $ctrl.getClonedWidgetStyle();
                style.repeatTableHeaders = value;
                flowingPages.updateWidgetStyle($ctrl.widgetId, style);
                widgetManager.notifyWidget($ctrl.widgetId, 'widgetStyleChanged', 'WidgetStyleController');
                widgetManager.notifyWidget($ctrl.widgetId, 'resized', 'WidgetStyleController');
            },
            hideTableHeader: function (value) {
                if (!$ctrl.widgetId) {
                    return;
                }
                var style = $ctrl.getClonedWidgetStyle();
                style.hideTableHeader = value;
                flowingPages.updateWidgetStyle($ctrl.widgetId, style);
                var nodeName = HIDE_HEADER_ROW_PREFIX + $ctrl.widgetId;
                if (value) {
                    widgetStylesService.applyHideHeaderRow($ctrl.widgetId, nodeName, value);
                }
                else {
                    styleNode.removeCSSNode(nodeName);
                }
                widgetManager.notifyWidget($ctrl.widgetId, 'widgetStyleChanged', 'WidgetStyleController');
                widgetManager.notifyWidget($ctrl.widgetId, 'resized', 'WidgetStyleController');
            },
            enableFirstColumnWidth: function (value) {
                if (!$ctrl.widgetId) {
                    return;
                }
                var style = $ctrl.getClonedWidgetStyle();
                style.enableFirstColumnWidth = value;
                flowingPages.updateWidgetStyle($ctrl.widgetId, style);
                if (value) {
                    this.setFirstColumnWidth(style.firstColumnWidth);
                }
                else {
                    // Remove Column Width Changes:
                    this.setFirstColumnWidth();
                }
            },
            setFirstColumnWidth: function (value) {
                if (!$ctrl.widgetId) {
                    return;
                }
                var nodeName = SET_FIRST_COLUMN_WIDTH_PREFIX + $ctrl.widgetId;
                if (value) {
                    var style = $ctrl.getClonedWidgetStyle();
                    style.firstColumnWidth = value;
                    flowingPages.updateWidgetStyle($ctrl.widgetId, style);
                    widgetStylesService.applyFirstColumnWidth($ctrl.widgetId, nodeName, value);
                }
                else {
                    styleNode.removeCSSNode(nodeName);
                }
                // Needed in case the first column pushes others onto a new line:
                widgetManager.notifyWidget($ctrl.widgetId, 'widgetStyleChanged', 'WidgetStyleController');
                widgetManager.notifyWidget($ctrl.widgetId, 'resized', 'WidgetStyleController');
            },
            showStyleOptions: function () {
                return _.includes(WIDGET_TYPES_WITH_STYLE, $ctrl.getWidgetType());
            },
            getWidgetPadding: function () {
                return flowingPages.getWidget($ctrl.widgetId).layout.padding;
            },
            getWidgetUnit: function () {
                return globalOptionsService.getUnit();
            },
            updateWidgetPadding: function (padding) {
                if (!$ctrl.widgetId) {
                    return;
                }
                var widgetId = $ctrl.widgetId;
                flowingPages.updateWidgetPadding(widgetId, padding);
                widgetManager.notifyWidget(widgetId, 'widgetPaddingChanged', 'WidgetPaddingController');
                widgetManager.notifyWidget(widgetId, 'resized', 'WidgetPaddingController');
            },
            getWidgetFixedHeightOption: function () {
                return widgetUtils.isFixedHeightWidget($ctrl.widgetId);
            },
            showAutoHeightOption: function () {
                var widget = getWidget();
                return autoHeight.isAutoHeightOptional(widget._type);
            },
            updateFixedHeightOption: function (useFixedHeight) {
                var widget = getWidget();
                widgetUtils.updateWidgetFixedHeightOption($ctrl.widgetId, useFixedHeight);
                eventService.trigger('widgetSwitch', widget._type);
            },
            deleteWidget: function () {
                widgetService.deleteWidgets($ctrl.widgetId);
            },
            showPaddingOptions: function () {
                var widgetType = _.get(flowingPages.getWidget($ctrl.widgetId), '_type');
                return !_.includes(WIDGET_TYPES_WITHOUT_PADDING, widgetType);
            },
            hasMultipleSelectedWidgets: function () {
                return $ctrl.selectedWidgetIds.length > 1;
            },
            shouldShowWidgetSidebar: function () {
                return this.widgetId || this.shouldShowBulkSidebar();
            },
            shouldShowBulkSidebar: function () {
                return this.hasMultipleSelectedWidgets();
            },
            // Chunked widget IDs have <widgetId>.0, <widgetId>.1, etc for each chunk so we need to split the string to get the pure ID.
            getWidgetIds: function () {
                return this.selectedWidgetIds.map(function (widgetId) {
                    return widgetId.split('.')[0];
                });
            },
            getDisplayLogic: function () {
                var widgetIds = this.getWidgetIds();
                var uniqueDisplayLogics = _.uniq(_.map(widgetIds, function (widgetId) {
                    var _a;
                    var widget = widgetManager.getWidgetComponent(widgetId);
                    return (_a = widget.lifecycle) === null || _a === void 0 ? void 0 : _a.dataConfig.displayLogic;
                }));
                _.remove(uniqueDisplayLogics, _.isUndefined);
                return uniqueDisplayLogics.length > 1 ? BULK_DISPLAY_LOGIC : uniqueDisplayLogics.pop();
            },
            setDisplayLogic: function (displayLogic) {
                this.getWidgetIds().forEach(function (widgetId) {
                    var widget = widgetManager.getWidgetComponent(widgetId);
                    var displayLogicSupported = !!widget.lifecycle;
                    if (!displayLogicSupported) {
                        return;
                    }
                    widget.lifecycle.dataConfig.displayLogic = displayLogic;
                    widget.lifecycle.onDataConfigUpdated();
                    conditionalDisplayService.computeWidgetConditionalDisplay(widgetId, widget.lifecycle.dataConfig);
                });
                $ctrl.displayLogic = displayLogic;
            },
            deleteWidgets: function () {
                _.forEach(this.getWidgetIds(), function (widgetId) {
                    widgetService.deleteWidgets(widgetId);
                });
            }
        });
    }
    module.component('prOptionsPane', {
        restrict: 'E',
        templateUrl: options_pane_html_1.default,
        controller: OptionsPaneController,
        bindings: {
            widgetId: '<',
            selectedWidgetIds: '<'
        }
    });
})(angular.module('qualtrics.pr'));
